export const ownServer = {
    prodIp: "https://backend.thementalmentorwhelenrose.com",
    Name: "prod"
}